/* eslint-disable sort-keys */
import libraryManager from '../managers/LibraryManager';
import productManager from '../managers/ProductManager';

import { registerClass } from '../SatCoreRegistry';

export default class ItemBankService {
  // Placeholder method that can be overwritten by other satellites to sort the kebab options.
  static sortLibraryCardKebabOptions = (options) => {
    return options;
  }

  static hasApplicableLicensedBanks = async ({
    includeItemBankCount = true,
    includeResourceBankCount = false
  } = {}) => {
    const applicableLicensedBankCount = await this.fetchApplicableLicensedBankCount({
      includeItemBankCount,
      includeResourceBankCount
    });
    return typeof applicableLicensedBankCount === 'number' && applicableLicensedBankCount > 0;
  }

  static fetchApplicableLicensedBankCount = async ({
    includeItemBankCount = true,
    includeResourceBankCount = false
  } = {}) => {
    const licensedItemBankCount = includeItemBankCount ? (
      await this.fetchLicensedItemBankCount()
    ) : undefined;
    const licensedResourceBankCount = includeResourceBankCount ? (
      await this.fetchLicensedResourceBankCount()
    ) : undefined;

    if (typeof licensedItemBankCount === 'number' || licensedResourceBankCount === 'number') {
      let applicableLicensedBankCount = 0;
      applicableLicensedBankCount += typeof licensedItemBankCount === 'number' ? licensedItemBankCount : 0;
      applicableLicensedBankCount += typeof licensedResourceBankCount === 'number' ? licensedResourceBankCount : 0;
      return applicableLicensedBankCount;
    }
  }

  static fetchLicensedItemBankCount = async () => {
    const page = 0;
    const pageSize = 0; // set to 0 as we do not need any actual data; we just want the total count (i.e. pageTotal)
    const sortColumn = undefined;
    const sortDirection = undefined;
    const rawCount = await libraryManager.fetchLibraryItemBanks(page, pageSize, sortColumn, sortDirection, {
      onlyReturnTotalCount: true
    });
    const count = Number(rawCount);
    return !isNaN(count) ? count : undefined;
  };

  static fetchLicensedResourceBankCount = async ({
    userId
  } = {}) => {
    const page = 0;
    const pageSize = 0; // set to 0 as we do not need any actual data; we just want the total count (i.e. pageTotal)
    const sortColumn = undefined;
    const sortDirection = undefined;
    const classroomId = undefined;
    const rawCount = await productManager.fetchLicensedResourceProducts({
      userId,
      page,
      pageSize,
      sortColumn,
      sortDirection,
      classroomId,
      onlyReturnTotalCount: true
    });
    const count = Number(rawCount);
    return !isNaN(count) ? count : undefined;
  }
}

registerClass('ItemBankService', ItemBankService);
